import { Injectable } from '@angular/core';
import { pagos } from './models/pagos';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HistorialpagosService {

  constructor(private http: HttpClient) { }

  getPagos(nrocta: string, anio: number, cuota:number): Observable<pagos> {
    return this.http.get<pagos>(
      `${environment.urlService}/DeudaBien/HistorialPagos?p_Jurisdiccion=${environment.codigoJur}&p_anio_cuota=${anio}&p_nro_cuota=${cuota}&clave_bien=${nrocta}`
    );
  }

}
